import React, { useEffect, useState } from 'react';
import styled from "styled-components";
import {Col, Container, Row} from "react-bootstrap";
import ButtonSubmit from "../ButtonSubmit";
import {hover, semibold, text} from "../../styles/globalStyleVars";
import Select from "react-select";
import ProjectSingle from "../ProjectSingle";
import reactHtmlParser from "react-html-parser";

const MyComponent = ({data,types}) => {

    const [filterData, setFilterData] = useState(data);
    const [activeIndex, setActiveIndex] = useState(null);

    const handleClick = (item,index) =>{
        let filteredData=item? data?.filter(element=>element?.type?.name===item) : data;
        setFilterData(filteredData? filteredData : data);
        setActiveIndex(index? index : null);
    }

    const handleMobileClick = (item,index) =>{
        let filteredData=item? data?.filter(element=>element?.type?.name===item?.[0]) : data;
        setFilterData(filteredData? filteredData : data);
        setActiveIndex(index? index : null);
    }

    const DropdownOption = [
        {value: 'report', label: 'Project Type'},
        {value: 'dashboard', label: 'Project Type'},
        {value: 'news_flash', label: 'Project Type', id: 6},
        {value: 'blog', label: 'Project Type'},
        {value: 'expert', label: 'Project Type'},
    ];

    const options = types?.map(option => ({value: reactHtmlParser(option), label: reactHtmlParser(option)}));

    return (
        <StyledComponent>
            <Container>
                <Row>
                    <Col md={12} className={'filter filter_new_design'}>
                        <ul className={'desktop'}>
                            {
                                types && types?.length>0 &&
                                types?.map((element,index)=>{
                                    return(
                                        <li className={index === activeIndex ? 'active' : ''}
                                            onClick={() => handleClick(element,index)} key={index}>
                                            <ButtonSubmit border={'1px'} borderColor={'rgba(60,60,59,0.5)'} width={'100'}
                                                          text={element} color={'#3C3C3B'}
                                                          hoverBackground={`${hover}`}
                                                          background={'transparent'}/>
                                        </li>
                                    )}
                                )
                            }
                        </ul>
                        <div className="mobile">
                            <Select
                                placeholder={'All'}
                                onChange={(e) => handleMobileClick(e.value, e?.id)}
                                styles={{
                                    dropdownIndicator: (provided, state) => ({
                                        ...provided,
                                        transform: state.selectProps.menuIsOpen && "rotate(180deg)"
                                    }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        // backgroundColor: state.isSelected ? '#221F1F' : '#FFF',
                                        "&:hover": {
                                            // backgroundColor: "transparent",
                                            // color: '#222222',
                                            cursor: 'pointer'
                                        },
                                    }),
                                    menu: (provided)=>({
                                        ...provided,
                                        zIndex: 999999999
                                    })
                                }}
                                classNamePrefix={'react-select'}
                                className={'form-select'}
                                options={options}
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                    colors: {
                                        ...theme.colors,
                                        primary25: '#e9e9e9',
                                        primary: 'black',
                                    },

                                })}
                            />
                        </div>
                    </Col>
                </Row>

                <Row>
                    {
                        filterData?.length ?
                            filterData?.map((element)=>{
                                return(
                                    <Col sm={6}>
                                        <ProjectSingle img={element?.thumb ? element?.thumb :'/images/static/default-thumb.svg'} title={element?.type?.name}
                                                       desc={element?.post_title} key={element?.ID}
                                                       link={`project/${element?.post_name}`}/>
                                    </Col>
                                )
                            }) :
                            data?.map((element)=>{
                                return(
                                    <Col sm={6}>
                                        <ProjectSingle img={element?.thumb ? element?.thumb :'/images/static/default-thumb.svg'} title={element?.type?.name}
                                                       desc={element?.post_title} key={element?.ID}
                                                       link={`project/${element?.post_name}`}/>
                                    </Col>
                                )
                            })
                    }
                </Row>
            </Container>
        </StyledComponent>
    );
};
const StyledComponent = styled.section`

  padding-top: 60px;
  padding-bottom: 140px;
  
  //filter new design 
  .filter_new_design {
    margin-bottom: 60px;
    ul {
      gap: 0;
      justify-content: space-between;
      flex-wrap: wrap;
      li {
        width: calc(30% -30)px; /* Adjust the width based on your requirements */
        margin-bottom: 10px;
        &.active {
          span {
            color: ${hover};
          }

          a {
            &:before {
              transform: unset;
              opacity: 1;
            }
          }
        }
      }
    }

    .dc-btn {
      a {
        border-radius: 0;
        border-left: none !important;
        border-right: none !important;
        border-top: none !important;
        border-bottom: none !important;
        line-height: 20px;

        &:before {
          height: 2px !important;
          border-radius: 0;
          top: unset;
          bottom: 0;
          transform: unset;
          opacity: 0;
        }

        &:after {
          content: '';
          background: rgba(198, 198, 198, 0.5);
          height: 1px;
          width: 100%;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
        }

        &:hover {
          span {
            color: ${hover};
          }

          &:before {
            transform: unset;
            opacity: 1;
          }
        }
        span{
          color: ${text};
          font-size: 16px;
          line-height: 20px;
          font-family: ${semibold};
        }
      }
    }
  }
  
  .desktop{
    display: flex;
  }
  .mobile{
    display: none;
  }

  .react-select__control {
    padding: 0px 0px 0px 15px;
    height: 45px;
    box-sizing: border-box;
    border: 1px solid rgba(60, 60, 59, 0.5);
    border-radius: 22px;
    display: flex;
    -webkit-box-pack: justify;
    width: 100%;
    min-width: 330px;
    align-items: center;
    justify-content: center;

  }

  .css-1jqq78o-placeholder {
    color: rgb(60, 60, 59);
    margin-left: 0;
    margin-right: 0;
    box-sizing: border-box;
    line-height: 41px;
  }
  @media(max-width: 767px){
    padding-bottom: 120px;
    .desktop{
      display: none;
    }
    .mobile{
      display: block;
    }
  }
`
export default MyComponent;